export const commitee = [
    {
        id: 1,
        name: 'PROF. DAVID DODOO-ARHIN',
        affiliation: 'LOC Chairman',
    },
    {
        id: 2,
        name: 'PROF BENJAMIN AGYEI-TUFFOUR',
        affiliation: 'LOC Secretary',
    },
    {
        id: 3,
        name: 'DR. YIPORO DANYUO',
        affiliation: 'Ashesi University',
    },
    {
        id: 4,
        name: 'PROF AZEKO TAHIRU SALIFU',
        affiliation: 'TTU-Tamale',
    },
    {
        id: 5,
        name: 'DR. EMMANUEL KWESI ARTHUR',
        affiliation: 'KNUST',
    },
    {
        id: 6,
        name: 'DR. MICHEAL OTENG-PEPRAH',
        affiliation: 'UCC',
    },
    {
        id: 7,
        name: 'MADAM ADELAIDE ASANTE',
        affiliation: 'AIMS-Ghana',
    },
    {
        id: 8,
        name: 'MRS. REBECCA HAYFORD-ADU',
        affiliation: 'AMRS-UG Chapter',
    },
    {
        id: 9,
        name: 'MAAME YAA ADOMAKO',
        affiliation: 'AMRS-UG Chapter',
    },
    {
        id: 10,
        name: 'MR. KWAME MARFO',
        affiliation: 'UG/Attachy Construction',
    },
    {
        id: 11,
        name: 'VERY REV. SELASIE GBOGBO',
        affiliation: 'AMRS-UG Chapter',
    },
    {
        id: 12,
        name: 'MR. REUBEN RICHTER',
        affiliation: 'UG',
    },
    {
        id: 13,
        name: 'MR. KANKAM ABRAMPA YEBOAH',
        affiliation: 'UG',
    },
    {
        id: 14,
        name: 'MR. SOLOMON FELICIEN',
        affiliation: 'UG',
    },
    {
        id: 15,
        name: 'MS. BARBARA OBEMPONG',
        affiliation: 'UG',
    },
    {
        id: 16,
        name: 'MRS. MAAME HUTCHFUL NORTEY',
        affiliation: 'ORID, UG',
    },
    {
        id: 17,
        name: 'PROF. EMMANUEL NYANKSON',
        affiliation: 'UG',
    },
    {
        id: 18,
        name: 'DR. HENRY OFOSUHENE SINTIM',
        affiliation: 'IAST',
    },
    {
        id: 19,
        name: 'DR. JOSEPH ASARE',
        affiliation: 'UG',
    },
    {
        id: 20,
        name: 'MS. VICTORIA ABOAGYE-NYAMEKYE',
        affiliation: 'UMB BANK',
    },
    {
        id: 21,
        name: 'MR. JOHN YIRIJOR',
        affiliation: 'Acadmeic City College',
    },
    {
        id: 22,
        name: 'PROF. EBENEZER ANNAN',
        affiliation: 'UG',
    }
]